import {InjectionToken} from '@angular/core';
import { ApiClient } from './services/http/api-client';

export const RESTANGULAR_INTEGRATION_SERVER = new InjectionToken<ApiClient>('RestangularIntegration');
